import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSolusComponent } from './simple-icons-solus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSolusComponent ],
    exports:      [ SimpleIconsSolusComponent ],
    bootstrap:    []
})
export class SimpleIconsSolusModule {}
